import { Link } from 'react-router-dom';
import { LuCode, LuFlame, LuTrophy } from 'react-icons/lu';
import { Brand } from './Brand';
import { AuthScene } from './AuthScene';
import { CodeShowcase } from './CodeShowcase';
import { useStrings, useTenant } from '../tenant/TenantProvider';
import { useMediaQuery } from '../hooks/useMediaQuery';

const FEATURE_ICONS = [LuCode, LuFlame, LuTrophy];

function Showcase() {
  const t = useStrings();
  const { list } = useTenant();
  const features = list('auth.showcase.features');
  return (
    <section className="auth__showcase" aria-labelledby="auth-headline">
      <Link to="/login" className="brand auth__brand">
        <Brand />
      </Link>
      <div className="auth__pitch">
        <h2 id="auth-headline" className="auth__headline">
          <span className="auth__headline-line">{t('auth.showcase.headline')}</span>
          <span className="auth__headline-line auth__headline-line--accent">{t('auth.showcase.headlineAccent')}</span>
        </h2>
        <p className="auth__lede">{t('auth.showcase.lede')}</p>
      </div>
      <CodeShowcase />
      {Array.isArray(features) && features.length > 0 && (
        <ul className="auth__features">
          {features.map((feature, index) => {
            const Icon = FEATURE_ICONS[index % FEATURE_ICONS.length];
            return (
              <li key={index} className="auth__feature">
                <Icon aria-hidden="true" />
                <span>
                  <strong>{feature?.title}</strong>
                  <span>{feature?.text}</span>
                </span>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}

export function AuthLayout({ title, subtitle, children, footer }) {
  const wide = useMediaQuery('(min-width: 1081px)');
  return (
    <div className="auth">
      <AuthScene />
      <div className="auth__layout">
        {wide && <Showcase />}
        <main className="auth__side">
          <div className="auth__panel energy energy--glow">
            <Link to="/login" className="brand auth__panel-brand">
              <Brand />
            </Link>
            <h1 className="auth__title">{title}</h1>
            {subtitle && <p className="auth__subtitle">{subtitle}</p>}
            <div className="auth__body">{children}</div>
            {footer && <div className="auth__footer">{footer}</div>}
          </div>
        </main>
      </div>
    </div>
  );
}
